(function ($, Promise) {

		// Constructor
		function SkillGamesGame3SlotIndicator(parent, data) {

			this.parent = parent;

			this.angle = data.angle;
			this.position = {
				x: constrain(data.x, 0, 1920),
				y: constrain(data.y, 100, 1080),
			}
			this.linkedPlane = false;

			// Graphic holder
			this.graphic = new PIXI.Container();
			this.texture = PIXI.Texture.from('images/skill_games/landing_airplanes/LYVLC_3.1.6_glow.png');
			this.sprite = new PIXI.Sprite(this.texture);
			this.graphic.position.x = this.position.x;
			this.graphic.position.y = this.position.y;
			this.sprite.anchor.set(0.5);
			this.sprite.alpha = 0;
			this.sprite.blendMode = PIXI.BLEND_MODES.SCREEN;
			this.graphic.addChild(this.sprite);

			this.animation = this.createAnimationTimeline();

			setInterval($.proxy(this.checkLinkedPlane, this), 1000);
		}

		SkillGamesGame3SlotIndicator.prototype.setPosition = function (x, y) {
			this.position.x = x;
			this.position.y = y;
			this.graphic.position.x = x;
			this.graphic.position.y = y;
		}

		SkillGamesGame3SlotIndicator.prototype.setAngle = function (value) {
			this.angle = value;
			this.graphic.rotation = value;
		}

		SkillGamesGame3SlotIndicator.prototype.createAnimationTimeline = function () {

			// Animate timeline
			var tl = new TimelineMax({
				repeat: -1,
				paused: true,
			});

			// Animate in
			tl.fromTo(this.sprite.scale, 0.5, {
				x: 0.8,
				y: 0.8,
			}, {
				x: 1,
				y: 1,
				easing: Sine.easeInOut,
			}, "+=0.0");

			tl.fromTo(this.sprite.scale, 0.5, {
				x: 1,
				y: 1,
			}, {
				x: 0.8,
				y: 0.8,
				easing: Sine.easeInOut,
			}, "+=0.0");

			return tl;
		}

		SkillGamesGame3SlotIndicator.prototype.enable = function (value, linkedPlane) {

			if (linkedPlane) {
				this.linkedPlane = linkedPlane;
			}

			if (value) {
				this.enabled = value;
				this.animation.play();

				TweenMax.to(this.sprite, 0.5, {
					alpha: 0.8,
					easing: Sine.easeInOut,
				}, "+=0.0");

			} else {
				this.enabled = value;
				this.animation.stop();
				this.linkedPlane = false;

				TweenMax.to(this.sprite, 0.5, {
					alpha: 0,
					easing: Sine.easeInOut,
				}, "+=0.0");
			}
		}

		SkillGamesGame3SlotIndicator.prototype.checkLinkedPlane = function () {
			if (this.enabled && this.linkedPlane) {
				if (this.linkedPlane.position.x > 50 && this.linkedPlane.position.x < 1870 && this.linkedPlane.position.y > 50 && this.linkedPlane.position.y < 1020) {
					this.enable(false, false);
				}
			}
		}

		SkillGamesGame3SlotIndicator.prototype.reset = function () {
			this.enable(false, false);
			this.linkedPlane = false;
		}

		// Expose SkillGamesGame3SlotIndicator
		window.SkillGamesGame3SlotIndicator = SkillGamesGame3SlotIndicator;
	}
)
(jQuery, Promise);
